import type TaxInfo from "../../TaxInfo";
import { roundPrice } from "~/utils/payment";
import type { TaxInfoType } from "../../TaxInfoType";
import type ProgramServiceTaxStrategy from "./ProgramServiceTaxStrategy";
import type AccountProgramServiceInfo from "~/domains/payment/account/AccountProgramServiceInfo";

export default class SalesProgramServiceTaxStrategy implements ProgramServiceTaxStrategy {
  getTaxInfoType(): TaxInfoType {
    return "sales";
  }

  getTaxInfo(tax: TaxInfo, programService: AccountProgramServiceInfo): TaxInfo {
    return {
      ...tax,
      amount: roundPrice((programService.totalPrice ?? 0) * (tax.value ?? 0), "down", 2),
    };
  }
}